
(() => {
  const GIFT_VARIANT_ID = 57048217092441;
  const MINIMUM_CENTS = 5000;
  const ROOT = window.Shopify?.routes?.root || '/';

  let updating = false;
  let pending = false;

  const cartUrl = (path) => `${ROOT}${path}`;

  async function getCart() {
    const response = await fetch(cartUrl('cart.js'));
    if (!response.ok) throw new Error('Error consultando el carrito');
    return response.json();
  }

  async function refreshCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const sections = drawer.getSectionsToRender();
    const ids = sections.map((section) => section.id);

    const response = await fetch(
      `${cartUrl('')}?sections=${ids.join(',')}`
    );

    if (!response.ok) throw new Error('Error actualizando el carrito');

    const html = await response.json();

    drawer.renderContents({
      id: GIFT_VARIANT_ID,
      sections: html
    });
  }

  async function syncGift() {
    if (updating) {
      pending = true;
      return;
    }

    updating = true;

    try {
      const cart = await getCart();

      const gifts = cart.items.filter(
        (item) =>
          item.variant_id === GIFT_VARIANT_ID &&
          item.properties?._labb_free_gift === 'true'
      );

      const subtotal = cart.items
        .filter((item) => item.variant_id !== GIFT_VARIANT_ID)
        .reduce((sum, item) => sum + item.final_line_price, 0);

      let changed = false;

      if (subtotal >= MINIMUM_CENTS && gifts.length === 0) {
        const response = await fetch(cartUrl('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: GIFT_VARIANT_ID,
              quantity: 1,
              properties: { _labb_free_gift: 'true' }
            }]
          })
        });

        if (!response.ok) throw new Error('Error añadiendo el regalo');
        changed = true;
      }

      if (subtotal < MINIMUM_CENTS && gifts.length > 0) {
        for (const gift of gifts) {
          const response = await fetch(cartUrl('cart/change.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: gift.key,
              quantity: 0
            })
          });

          if (!response.ok) throw new Error('Error eliminando el regalo');
        }

        changed = true;
      }

      if (changed) {
        await refreshCartDrawer();
      }
    } catch (error) {
      console.error('LAB(B) Free Gift:', error);
    } finally {
      updating = false;

      if (pending) {
        pending = false;
        syncGift();
      }
    }
  }

  // Detectar cambios en el carrito realizados por Dawn
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      syncGift();
    });
  }

  // Comprobar también cambios realizados por otras aplicaciones
  let previousCart = '';

  async function watchCart() {
    if (updating) return;

    try {
      const cart = await getCart();
      const signature = JSON.stringify(
        cart.items.map((item) => [
          item.key,
          item.quantity,
          item.final_line_price
        ])
      );

      if (signature !== previousCart) {
        previousCart = signature;
        await syncGift();
      }
    } catch (error) {
      console.error('LAB(B) Cart Watch:', error);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    watchCart();
    setInterval(watchCart, 1500);
  });
})();


